<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                SnelStart administratie inlezen
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Bij de klantinstellingen is het een koppeling te maken met een Snelstart administratie. Vervolgens kun
                je er voor kiezen de gegevens uit de administratie te gebruiken bij de belastingaangifte. De voor de
                aangifte benodigde gegevens worden dan ingelezen in de aangifte inkomstenbelasting.
                <br/>
                <br/>
                Een voorwaarde voor het inlezen is dat de boekhouding 'RGS Ready' is. Dit houdt in dat de
                grootboekrekeningen voorzien zijn van de juiste RGS-codes. Meer informatie daarover vind je hier:
                <a href="https://kennisplein.snelstart.nl/klanten/s/article/rgs-en-snelstart" target="_blank">RGS
                    Ready</a>.

                <br/><br/>

                <b>WIJZIGINGEN IN DE ADMINISTRATIE</b><br/>
                Let op! Als je voor de eerste keer de gegevens uit een SnelStart administratie gebruikt, dan worden de
                gegevens uit de boekhouding van dat moment ingelezen. Maak je daarna wijzigingen in de administratie,
                dan worden deze <u>NIET AUTOMATISCH</u> bijgewerkt in de fiscale aangifte. Dat is om te voorkomen dat de
                in de aangifte gedane aanpassingen onbedoeld worden overschreven.
                <br/><br/>
                Door opnieuw te kiezen voor 'Administratie inlezen' kun je er wel zelf voor kiezen de meest actuele administratie overnemen in de
                aangifte.
            </div>
        </div>
    </div>
</div>
